import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { PadlockService } from "../../padlock/padlock.service";

export interface DirectoryUser {
  uuid: string;
  email: string;
  username?: string;
  tenant?: string;
  [key: string]: any;
}

@Injectable({ providedIn: "root" })
export class UsersManagementService {
  constructor(private padlockService: PadlockService) {}

  getUsers(search?: string): Observable<DirectoryUser[]> {
    return this.padlockService
      .getDirectoryUsers(search)
      .pipe(map((response: any) => this.normalizeUsers(response)));
  }

  resetPassword(userId: string): Observable<string | null> {
    return this.padlockService
      .resetUserPassword(userId)
      .pipe(map((response: any) => this.extractTemporaryPassword(response)));
  }

  deleteUser(userId: string): Observable<void> {
    return this.padlockService.deleteUser(userId).pipe(map(() => undefined));
  }

  private normalizeUsers(response: any): DirectoryUser[] {
    const users = Array.isArray(response)
      ? response
      : response?.users || response?.results || response?.data || [];

    if (!Array.isArray(users)) {
      return [];
    }

    return users.map((user) => ({
      ...user,
      uuid:
        user.uuid ||
        user.user_uuid ||
        user.user_id ||
        user.userId ||
        user.id ||
        "",
      email: user.email || user.user_email || "",
      username: this.extractUsername(user),
      tenant: this.extractTenant(user),
    }));
  }

  private extractUsername(user: any): string {
    return (
      user?.user_name || user?.username || user?.name || user?.userName || ""
    );
  }

  private extractTenant(user: any): string {
    const candidate =
      user?.tenant ||
      user?.tenant_name ||
      user?.tenant_uuid ||
      user?.tenant_id ||
      user?.tenant_label ||
      user?.workspace_name ||
      user?.workspace;

    if (Array.isArray(candidate)) {
      return candidate.filter(Boolean).join(", ");
    }

    return candidate || "";
  }

  private extractTemporaryPassword(response: any): string | null {
    return (
      response?.temporary_password ||
      response?.temporaryPassword ||
      response?.temp_password ||
      response?.password ||
      null
    );
  }
}
